import type { TFunction } from 'i18next';
import { IconDiscountCheck } from '@tabler/icons-react';

import articleIcon from 'src/assets/images/article-icon.svg';
import discoverNewIconSmall from 'src/assets/images/discover-new-icon-small.svg';
import DiscoverAutomatedBadge from 'src/components/discover-automated-badge/DiscoverAutomatedBadge';
import FilterButtonIcon from 'src/components/discover-filter-button-icon/FilterButtonIcon';

export const groupedMultiSelectFilterValues = [
  'recommended',
  'automated',
  'new-topics',
  'hidden',
  'article-generated',
];

export const getGroupedMultiSelectFilterOptions = (
  t: TFunction<'discover'>,
) => [
  {
    label: t('filters.recommended'),
    optionStartAdornment: <IconDiscountCheck size={20} />,
    value: 'recommended',
  },
  {
    label: t('filters.automated'),
    optionStartAdornment: <DiscoverAutomatedBadge size={20} />,
    value: 'automated',
  },
  {
    label: t('filters.newTopics'),
    optionStartAdornment: (
      <img alt={t('newTopicBadge.alt')} src={discoverNewIconSmall} />
    ),
    value: 'new-topics',
  },
  {
    label: t('filters.hidden'),
    optionStartAdornment: <FilterButtonIcon dropdownType='show-all' />,
    value: 'hidden',
  },
  {
    label: t('filters.articleGenerated'),
    optionStartAdornment: (
      <img
        alt={t('filters.articleAlt')}
        src={articleIcon}
        style={{ marginRight: '1px' }}
      />
    ),
    value: 'article-generated',
  },
];
